module.exports = __webpack_public_path__ + "static/media/view--off.a9727deb.svg";